export { default } from './ChangeLanguage';
